import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { MODAL_TYPE } from "../../utils";
import './modal.scss'
import ExpandPdf from "./expand-pdf";
import  FeedbackForm  from "./feedback";

export const Modal = () => {
  const { modal } = useSelector((state: RootState) => state.ui);
  
  return (
    <>
      {modal[MODAL_TYPE.EXPAND_PDF] && <ExpandPdf />}
      {modal[MODAL_TYPE.FEEDBACK] && <FeedbackForm />}
    </>
  );
};
